import Vue from 'vue';
import Button from 'primevue/button';

Vue.component('Button', Button);
